import { UPDATE_PARALIZADOS } from '../actionTypes';

export const updateParalizados = (payload) => ({
	type: UPDATE_PARALIZADOS,
	payload,
});
